import { useUpsertClaimantPolicyNote } from "@/hooks/useUpsertClaimantPolicyNote";
import { InlineNoteCell } from "./InlineNoteCell";

interface ClaimantPolicyNoteCellProps {
  claimantId: string;
  /** Selected policy id; the note is scoped to (claimant, policy). */
  policyId?: string;
  /** Current note from policy_data[policyId].note. */
  note?: string;
  /** Whether the user may edit (claimants:edit + not read-only partner). */
  canEdit: boolean;
  /** block = full-width section (claimant page); default = compact table cell (Summary). */
  block?: boolean;
}

/**
 * Editable cell/section for the policy-period-scoped claimant Note
 * (US 5273 / ADR-052 §10). Writes via the dedicated upsert endpoint — not the
 * synced policy_data JSONB. Used on the Claims Summary Summary Table and the
 * claimant detail page.
 */
export const ClaimantPolicyNoteCell = ({ claimantId, policyId, note, canEdit, block }: ClaimantPolicyNoteCellProps) => {
  const { saveNote } = useUpsertClaimantPolicyNote();
  // Editing requires both a claimant and a policy to scope the note to — without
  // both, the endpoint path would be malformed (e.g. claimants//policy-notes/…).
  const editable = canEdit && !!policyId && !!claimantId;
  return (
    <InlineNoteCell
      note={note}
      canEdit={editable}
      block={block}
      onSave={(value) => saveNote(claimantId, policyId as string, value)}
    />
  );
};
